import React from "react";
import { navigate } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import PropTypes from "prop-types";
import { useInView } from "react-intersection-observer";

// components
import Button from "../../Button/Button";

// styles
import * as styles from "./JoinTwin.module.css";

const JoinTwin = ({ onCtaClick }) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const handleJoinUsClick = () => {
    // Track Mixpanel event
    if (onCtaClick) {
      onCtaClick("Join Us", "Join Twin Section");
    }

    // Navigate to career page OpenRoles section
    navigate("/career/#open-roles");
  };

  return (
    <section className={styles.joinTwinSection}>
      <div
        className={`container scroll_animate ${inView && "inview"}`}
        ref={ref}
      >
        <div className="row">
          <div className="col-12">
            <div className={styles.joinTwinCard}>
              {/* Desktop Image */}
              <div className={styles.desktopImage}>
                <StaticImage
                  src="../../../images/aboutUs/join-banner-desk.png"
                  alt="Join Twin"
                  placeholder="blurred"
                  quality={100}
                  className={styles.bannerImage}
                  loading="lazy"
                />
              </div>

              {/* Mobile Image */}
              <div className={styles.mobileImage}>
                <StaticImage
                  src="../../../images/aboutUs/join-banner-mob.png"
                  alt="Join Twin"
                  placeholder="blurred"
                  quality={100}
                  className={styles.bannerImage}
                  loading="lazy"
                />
              </div>

              {/* Content Overlay */}
              <div className={styles.contentOverlay}>
                <div className={styles.contentWrapper}>
                  <h2 className={styles.title}>Join Twin</h2>
                  <p className={styles.description}>
                    Explore life at Twin and Start your Journey with us
                  </p>
                  <Button
                    text="Join Us"
                    variant="primary"
                    size="lg"
                    onClick={handleJoinUsClick}
                    btnClass={styles.joinButton}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

JoinTwin.propTypes = {
  onCtaClick: PropTypes.func,
};

JoinTwin.defaultProps = {
  onCtaClick: null,
};

export default JoinTwin;
